import type { PropsWithChildren } from "react";

import { useLocation, useSearchParams } from "react-router";

import { StaticRouteNavigate } from "@/modules/static-route";
import { useAuthContext } from "@/services/auth";

export const AppRouteGate = ({ children }: PropsWithChildren) => {
  const { hasToken } = useAuthContext();
  const location = useLocation();
  const [searchParams] = useSearchParams();

  if (searchParams.get("error_description")) {
    return (
      <StaticRouteNavigate route="sso_error" search={location.search} replace />
    );
  }

  // If user is not logged in, redirect to login page
  if (!hasToken) {
    return (
      <StaticRouteNavigate route="login" state={{ from: location }} replace />
    );
  }

  // Otherwise, render the route content
  return children;
};
